import { useEffect } from 'react';
import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import FullScreenIn from '../assets/images/FullScreenIn.svg';
import FullScreenOut from '../assets/images/FullScreenOut.svg';
import FullScreenDarkIn from '../assets/images/Repertoire/FullScreenDarkIn.svg';
import FullScreenDarkOut from '../assets/images/Repertoire/FullScreenDarkOut.svg';
import { iconContainerStyles1 } from './RoadmapComponents/Menu';
import * as appActions from '../Actions/app';
import { isCapacitorNative } from 'Utils/Constants';
import { useMediaQueries } from 'Hooks/useMediaQueries';

const Fullscreen = (props: { show_label: boolean; use_dark_icon?: boolean }) => {
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const dispatch = useDispatch();
  const { show_label } = props;
  const isFullScreen = data.isFullScreen;
  const { use_dark_icon } = props;
  const iconIn = use_dark_icon ? FullScreenDarkIn : FullScreenIn;
  const iconOut = use_dark_icon ? FullScreenDarkOut : FullScreenOut;

  const { maxHeight } = useMediaQueries();

  const textStyles = {
    fontFamily: 'Lato',
    marginTop: '10px',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: maxHeight > 750 ? '15px' : '12px',
    lineHeight: '18px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    color: '#ADB1B7',
  };

  const hoverBoxStyles = {
    marginTop: maxHeight > 750 ? '44px' : '30px',
    borderRadius: 4,
    opacity: 0.8,
    padding: '0px 0px 0px 0px',
    '&:hover': {
      background: 'hsla(15, 49.50%, 58.80%, 0.30)',
      cursor: 'pointer',
      transition: '0.3s',
      boxShadow: '0px 0px 6px 6px rgb(222,144,118,.3)',
    },
  };

  const fullScreenWidth = maxHeight > 750 ? 38 : 34;

  useEffect(() => {
    // This is needed so that if they hit excape to leave fullscreen, it will adjust
    const handleFullScreenChange = () => {
      const isNowFullScreen = !!document.fullscreenElement;
      dispatch(appActions.setFullScreen(isNowFullScreen));
    };
    document.addEventListener('fullscreenchange', handleFullScreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      dispatch(appActions.setFullScreen(true));
      document.documentElement.requestFullscreen().catch((e) => {
        console.error(`Error attempting to enable full-screen mode: ${e.message} (${e.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        dispatch(appActions.setFullScreen(false));
        document.exitFullscreen();
      }
    }
  };

  // No fullscreen button for mobile app.
  if (isCapacitorNative()) {
    return <></>;
  }

  if (show_label) {
    return (
      <Box
        sx={{
          ...iconContainerStyles1,
          ...hoverBoxStyles,
          display: 'flex',
          alignItems: 'center',
          position: 'fixed',
          bottom: '20px',
          left: '11px',
          width: '80px',
        }}
      >
        <img
          style={{ width: fullScreenWidth, opacity: 0.7, fill: 'black' }}
          src={isFullScreen ? iconOut : iconIn}
          onClick={toggleFullScreen}
        />
        <Box sx={{ ...textStyles, marginTop: '10px' }}>Full Screen</Box>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          '&:hover': {
            cursor: 'pointer',
          },
          width: '80px',
        }}
      >
        <img
          style={{ width: fullScreenWidth, opacity: 0.7, fill: 'black' }}
          src={isFullScreen ? iconOut : iconIn}
          onClick={toggleFullScreen}
        />
      </Box>
    );
  }
};
export default Fullscreen;
